import React from "react";
import get from "lodash.get";
import { TimeStamp } from "../TimeStamp";
import PropTypes from "prop-types";
import { Author } from "../Author";
import { Dot } from "../Dot/dot";
import { Divider } from "../Divider/";
import { useStateValue } from "../../SharedContext";

import "./author-with-timestamp.m.css";
import { getTextColor } from "../../../utils/utils";

export const AuthorWithTime = ({ story, separator, isBottom, hideAuthorImage, prefix }) => {
  const config = useStateValue() || {};
  const isAuthor = get(config, ["showAuthor"], true);
  const isTime = get(config, ["showTime"], true);
  const isBottomClasses = isBottom ? "bottom-fix" : "";
  const seperatorStyle = separator === "dot" ? "dot" : "dash";
  const textColor = getTextColor(config.theme);
  const getSeparator = () => {
    if (separator === "divider") {
      return <Divider color={textColor} />;
    }
    return <Dot color={textColor} />;
  };
  return (
    <div className="arr--author-time" styleName={`author-time-wrapper ${isBottomClasses}`}>
      {isAuthor && (
        <div styleName={`author`}>
          <Author story={story} isBottom hideAuthorImage={hideAuthorImage} prefix={prefix} />
        </div>
      )}
      {isAuthor && isTime && (
        <>
          <span className="arr-separator" styleName={`${seperatorStyle}`}>
            {getSeparator()}
          </span>
          <TimeStamp story={story} />
        </>
      )}
      {!isAuthor && isTime && <TimeStamp story={story} />}
    </div>
  );
};

AuthorWithTime.propTypes = {
  story: PropTypes.object,
  /** Style of separator between the Author & Timestamp */
  separator: PropTypes.oneOf(["dot", "divider"]),
  /** hide the author image */
  hideAuthorImage: PropTypes.bool,
  // fix author and time at the end
  isBottom: PropTypes.bool,
  // fix prefix before the author name
  prefix: PropTypes.string
};

AuthorWithTime.defaultProps = {
  separator: "dot",
  isBottom: false,
  hideAuthorImage: true,
  prefix: ""
};
